import { writable, get } from "svelte/store";

// ---register flow

export const flowData = writable({ loginDestination: "authenticate" });

export const openWorkshops = writable({});

export const userWorkshops = writable({});

export const transitionString = writable("forward");

export const portalStatus = writable({});

// ---register and lms flows
export const pageToLoad = writable();

export const pageStack = writable([]);

// currently only seem to be using .loggedIn (manually created), and .uid (from firebase auth) from user
export const user = writable({ loggedIn: false });

export const enableBackButton = writable(true);

export const selectedWorkshopID = writable();

export const sliderToLoad = writable();

export const appMode = writable("register");

// ---lms flow

export const activeWorkshop = writable({});

export const lessons = writable([]);

export const modules = writable([]);

export const currentLessonIndex = writable(0);

export const highestLessonIndex = writable(0);

export const activeLesson = writable({});
